<template>
    <span>
        <el-date-picker
            v-model="timeSearch.startTime"
            type="date"
            :placeholder="$t('tip.startTime')"
            :picker-options="pickerOptions1"
            @change="timeChange"
            value-format="yyyy-MM-dd">
        </el-date-picker>
        <span>{{$t('c.to')}}</span>
        <el-date-picker
            v-model="timeSearch.endTime"
            type="date"
            :placeholder="$t('tip.endTime')"
            :picker-options="pickerOptions2"
            @change="timeChange"
            value-format="yyyy-MM-dd">
        </el-date-picker>
    </span>
</template>

<script>
    export default {
        data() {
            return {
                timeSearch: {
                    startTime: undefined,
                    endTime: undefined
                }
            }
        },
        created() {
        },
        computed: {
            pickerOptions1() {
                let that = this;
                return {
                    disabledDate(time) {
                        if (!that.timeSearch.endTime) return false;
                        return time.getTime() > new Date(that.timeSearch.endTime).getTime()
                    },
                }
            },
            pickerOptions2() {
                let that = this;
                return {
                    disabledDate(time) {
                        if (!that.timeSearch.startTime) return false;
                        let dateTime = new Date(that.timeSearch.startTime);
                        dateTime=dateTime.setDate(dateTime.getDate()-1);
                        return time.getTime() < new Date(dateTime).getTime()
                    },
                }
            },
        },
        methods: {
            timeChange() {
                this.$emit('getTimePicker', this.timeSearch);
            }
        }
    }
</script>

<style scoped>

</style>
